import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { token } from '@atlaskit/tokens';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { fireUIAnalytics, ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import type { Props } from './types';
import { buildProjectURL } from './utils';

const ListProjects = ({ projects }: Props) => (
	<ListWrapper>
		<>
			{projects.map((project) => (
				<ItemWrapper key={project.id}>
					<ContextualAnalyticsData containers={{ project: { id: project.id } }}>
						<Avatar src={project.avatarUrls['16x16']} alt="projectAvatar" />
						<Link
							href={buildProjectURL(project)}
							// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
							onClick={(_, analyticsEvent: UIAnalyticsEvent) => {
								fireUIAnalytics(analyticsEvent, 'project');
							}}
						>
							{project.name}{' '}
						</Link>
					</ContextualAnalyticsData>
				</ItemWrapper>
			))}
		</>
	</ListWrapper>
);

export default ListProjects;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ListWrapper = styled2.div({
	display: 'flex',
	flexDirection: 'column',
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minHeight: `${6 * gridSize}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ItemWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	padding: `${token('space.050', '4px')} ${token('space.025', '2px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	a: {
		paddingLeft: token('space.100', '8px'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Avatar = styled2.img({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 3}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${gridSize / 2}px`,
});
